import { createMachine } from 'xstate';
import { Model } from 'xstate/lib/model.types';
import { BaseContext, BaseEvent, customElement, remoteMessage } from '../../../machine';
import React from 'react';

import { AddToMobileWalletFromGlobalData } from '../ZoryveDirect.components';
import { GLOBALS } from '../../../globals';

const WELCOME = 'WELCOME';
const ADD_TO_MOBILE_WALLET_EXISTING = 'ADD_TO_MOBILE_WALLET_EXISTING';
const QUESTIONS = 'QUESTIONS';

export const SAVINGS_LIMIT_MESSAGES = {
  WELCOME:
    `ALERT: Arcutis Savings Card Program Member ID: ${GLOBALS.initResponse.metadata.memberId ?? 'XXXXXXXXXX'} is nearing the max limit. You have used more than 75% of your benefit.`,
  ADD_TO_MOBILE_WALLET_EXISTING: <AddToMobileWalletFromGlobalData />,
  QUESTIONS:
    'Questions? Call 1-844-979-1288 from 6:00 am–5:00 pm PT, M–F. Text STOP to unsubscribe. Text TERMS for Terms and Conditions to 1-440-496-7983.',
};

/**
 * ZORYVE Direct Program Flow V2.0
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const ZoryveDirectLimitReminderFlow = (
  model: Model<BaseContext, BaseEvent, void>,
  initial = WELCOME
) =>
  createMachine<BaseContext, BaseEvent>({
    id: 'ZoryveDirectLimitReminderFlow',
    initial: initial ?? WELCOME,
    context: model.initialContext,
    states: {
      // Welcome Message
      [WELCOME]: remoteMessage({
        id: WELCOME,
        message: SAVINGS_LIMIT_MESSAGES.WELCOME,
        nextState: ADD_TO_MOBILE_WALLET_EXISTING,
      }),

      [ADD_TO_MOBILE_WALLET_EXISTING]: customElement({
        id: ADD_TO_MOBILE_WALLET_EXISTING,
        jsx: SAVINGS_LIMIT_MESSAGES.ADD_TO_MOBILE_WALLET_EXISTING,
        nextState: QUESTIONS,
      }),

      [QUESTIONS]: remoteMessage({
        id: QUESTIONS,
        message: SAVINGS_LIMIT_MESSAGES.QUESTIONS,
      }),
    },
  });
